import { Component, forwardRef } from '@angular/core';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { TenantFilterDto } from '@artemis-software/wr-api';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import FacilityElementEnum = TenantFilterDto.FacilityElementEnum;

@Component({
  standalone: false,
  selector: 'wr-facility-element-multi-select',
  templateUrl: './facility-element-multi-select.component.html',
  styleUrl: './facility-element-multi-select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FacilityElementMultiSelectComponent),
      multi: true,
    },
  ],
})
export class FacilityElementMultiSelectComponent extends AbstractFormControl<FacilityElementEnum>{
  readonly facilityElements = Object.values(FacilityElementEnum);
}
